<template>
  <v-card v-if="revealBack" class="c-card--back c-card--reveal g-skinny-scrollbars transition-fast-in-fast-out pa-4">
    <!-- header -->
    <v-list-item class="pa-0 mb-2">
      <!-- title -->
      <v-list-item-content class="align-self-start justify-end pa-0">
        <v-card-title
          class="pa-0 text-xs-caption text-sm-subtitle-2 text-md-subtitle-1 text-lg-h6 text-xl-h6 text-left"
        >
          {{ author ? $t('post.aboutAuthor') : $t('post.aboutSponsor') }}
        </v-card-title>
      </v-list-item-content>
      <!-- close button -->
      <v-btn
        class="align-self-start justify-end"
        icon
        large
        color="accent"
        @click.stop="$emit('click:reveal', false)"
      >
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-list-item>

    <v-card-text v-if="author" class="pa-0 mb-2">
      <PersonBanner class="pl-0 py-0" :person="author" />
      <ClampedPortableText class="mt-4" :localized-blocks="author.bio" />
    </v-card-text>

    <v-card-text v-if="sponsor" class="pa-0">
      <CompanyAvatar class="pl-0 py-0" :company="sponsor" />
      <ClampedPortableText class="mt-4" :localized-blocks="sponsor.bio" />
    </v-card-text>
  </v-card>
</template>

<script>
import ClampedPortableText from '@/components/base/ClampedPortableText'
import CompanyAvatar from '@/components/base/CompanyAvatar'
import PersonBanner from '@/components/person/PersonBanner'

export default {
  name: 'ChannelCardBack',

  components: {
    ClampedPortableText,
    CompanyAvatar,
    PersonBanner
  },

  model: {
    prop: 'reveal',
    event: 'click:reveal'
  },

  props: {
    reveal: {
      type: Boolean,
      required: true
    },

    author: {
      type: Object,
      required: false,
      default: null
    },

    sponsor: {
      type: Object,
      required: false,
      default: null
    }
  },

  data: function () {
    return {
      revealBack: this.reveal
    }
  },

  watch: {
    reveal: {
      immediate: false, // initial value captured via data()
      handler: function (newVal, _oldVal) {
        this.revealBack = newVal
      }
    }
  }
}
</script>

<style lang="css" scoped>
.c-card--back {
  border-radius: 16px;
  height: 100%;
  overflow-y: auto;
}
.c-card--reveal {
  top: 0;
  left: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
